"use client"

import { FragmentType, graphql, useFragment } from "@/gql"
import React, { type JSX } from "react"
import { GridBusinessCard } from "./components/GridBusinessCard"
import { ListBusinessCard } from "./components/ListBusinessCard"
import { BreadCrumbRef, NovaSession } from "@/types"
import { useRouter } from "next-nprogress-bar"

const CreativeBusinessCardFragment = graphql(`
  fragment CreativeBusinessCard on IndividualCreative {
    __typename
    id
    handle
    ...GridBusinessCard
    ...ListBusinessCard
  }
`)

interface Props {
  creative: FragmentType<typeof CreativeBusinessCardFragment> | undefined | null
  actionButtons?: JSX.Element
  type?: "grid" | "list"
  onlyShowActionsOnHover?: boolean
  serverSession: NovaSession
  breadCrumbRef?: BreadCrumbRef
  onClick?: () => void
  trackingEntryPoint: string
}

export const BusinessCard: React.FC<Props> = props => {
  const creative = useFragment(CreativeBusinessCardFragment, props.creative)
  const {
    type = "list",
    actionButtons,
    onlyShowActionsOnHover,
    serverSession,
    breadCrumbRef,
    onClick,
    trackingEntryPoint,
  } = props
  const router = useRouter()
  const isGridView = type === "grid"

  return (
    <div onClick={onClick}>
      <div
        className="hidden md:flex"
        onMouseEnter={() => {
          router.prefetch(`/${creative?.handle}`)
        }}>
        {isGridView ? (
          <GridBusinessCard
            creative={creative}
            actionButtons={actionButtons}
            onlyShowActionsOnHover={onlyShowActionsOnHover}
            serverSession={serverSession}
            breadCrumbRef={breadCrumbRef}
            trackingEntryPoint={trackingEntryPoint}
          />
        ) : (
          <ListBusinessCard
            breadCrumbRef={breadCrumbRef}
            creative={creative}
            actionButtons={actionButtons}
            serverSession={serverSession}
            trackingEntryPoint={trackingEntryPoint}
          />
        )}
      </div>
      <div className="md:hidden">
        <GridBusinessCard
          creative={creative}
          actionButtons={actionButtons}
          onlyShowActionsOnHover={onlyShowActionsOnHover}
          serverSession={serverSession}
          breadCrumbRef={breadCrumbRef}
          trackingEntryPoint={trackingEntryPoint}
        />
      </div>
    </div>
  )
}
